import {
  ContactType,
  IAdvancedTable,
  INew_TableAction,
  IPaginationFilteredResponse,
  ITimePeriodRequest
} from '@lla-platform/core/core-data-access'
import { ITagUpdateDateItem } from './customers-tag.interface'

// Column key type
export type ContactsColumnKey =
  | 'firstName'
  | 'lastName'
  | 'companyName'
  | 'hasGeoLocation'
  | 'phone'
  | 'email'
  | 'locationName'
  | 'invoicesCount'
  | 'totalWithoutTax'
  | 'totalWithTax'
  | 'lastInvoiceDate'

// Column definitions for the checkboxes on the config page
export interface IContactsColumnDefinition {
  key: ContactsColumnKey
  label: string
  group: 'identity' | 'contact' | 'location' | 'financial'
}

export const CONTACTS_COLUMN_DEFINITIONS: IContactsColumnDefinition[] = [
  { key: 'firstName', label: 'First Name', group: 'identity' },
  { key: 'lastName', label: 'Last Name', group: 'identity' },
  { key: 'companyName', label: 'Company Name', group: 'identity' },
  { key: 'phone', label: 'Phone', group: 'contact' },
  { key: 'email', label: 'Email', group: 'contact' },
  { key: 'hasGeoLocation', label: 'Has Geo Location', group: 'contact' },
  { key: 'locationName', label: 'Location Name', group: 'location' },
  { key: 'invoicesCount', label: 'No. of Invoices', group: 'financial' },
  { key: 'totalWithoutTax', label: 'Total (without Tax)', group: 'financial' },
  { key: 'totalWithTax', label: 'Total (with Tax)', group: 'financial' },
  { key: 'lastInvoiceDate', label: 'Last Invoice Date', group: 'financial' }
]

// Full config saved to state
export interface IContactsReportConfig {
  filters: ICustomersListRequest
  selectedColumns: ContactsColumnKey[]
}

export interface ICustomersListInfo {
  tableAction: INew_TableAction
  filters?: ICustomersListRequest
  selectedColumns?: ContactsColumnKey[]
}

export interface ICustomersListRequest {
  period?: ITimePeriodRequest
  lastInvoice?: boolean
  name?: string
  corporateContact?: boolean
  invoiceMin?: number
  invoiceMax?: number
  contactType?: ContactType[]
  tags?: ITagUpdateDateItem[]
  locationIds?: string[]
  hasGeoLocation?: boolean
  phone?: string
}

export interface ICustomersListItem extends IAdvancedTable {
  contactId: string
  locationId: string
  firstName: string
  lastName: string
  phone: string
  email: string
  companyName: string
  locationName: string
  invoicesCount: number
  totalWithoutTax: number
  totalWithoutTaxFormatted: string
  totalWithTax: number
  totalWithTaxFormatted: string
  lastInvoiceDate: Date
  hasGeoLocation: boolean
  contactLink?: string
}

export interface ICustomersListResponse extends IPaginationFilteredResponse {
  contacts: ICustomersListItem[]
  countWithGeoLocation: number
}
